import { AuthorizationInformationConstants } from '../store/authorizationInformation.constants'

export const authorizationInformationSchemas = [
  {
    inputKey: AuthorizationInformationConstants.SET_TRANSPORTAUTHORIZATIONCODE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TRANSPORTAUTHORIZATIONCODE: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,52}$',
      },
    },
    additionalProperties: false,
    required: ['SET_TRANSPORTAUTHORIZATIONCODE'],
    errorMessage: {
      properties: {
        SET_TRANSPORTAUTHORIZATIONCODE: 'Must be alphanumeric with max length of 52',
      },
    },
  },
  {
    inputKey: AuthorizationInformationConstants.SET_JUSTIFICATIONFORTRANSFER,
    isNumber: false,
    type: 'object',
    properties: {
      SET_JUSTIFICATIONFORTRANSFER: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,255}$',
      },
    },
    additionalProperties: false,
    required: ['SET_JUSTIFICATIONFORTRANSFER'],
    errorMessage: {
      properties: {
        SET_JUSTIFICATIONFORTRANSFER: 'Must be alphanumeric with max length of 255',
      },
    },
  },
]
